import Cookie from 'js-cookie';

/**
 * Liberação do chat guIAre por PERSONA — espelha config/guiare.php no backend.
 * Mantenha sincronizado se mudar o backend (o backend é a fonte de verdade e
 * barra o acesso de qualquer forma; aqui é só pra decidir o que exibir).
 *
 * - enabled: liga/desliga a persona.
 * - allowedUsernames:      se preenchido, restringe a estes usernames (cookie 'nome').
 * - allowedEmpreendimentos: se preenchido, restringe a estes empreendimento_id.
 */
const PERSONA_CONFIG = {
	construtora: { enabled: true,  allowedUsernames: ['sg2sistemas-empresa'] },
	sindico:     { enabled: true, allowedEmpreendimentos: [] },
	condomino:   { enabled: true, allowedEmpreendimentos: [] },
};

/**
 * Resolve a persona do usuário a partir dos cookies de sessão (mesma regra do
 * PersonaResolver do backend, baseada no campo `unidade`).
 */
export function chatPersona() {
	const unidade = (Cookie.get('unidade') || '').toLowerCase();
	const isConstrutora = ['true', true].includes(Cookie.get('is_construtora'));

	if (isConstrutora || unidade.includes('construtora')) return 'construtora';
	if (unidade.includes('comuns') || unidade.includes('sindico')) return 'sindico';
	return 'condomino';
}

/**
 * Segmento de rota da API do chat para a persona atual
 * (ex.: 'condomino' → /api/condomino/chat/...).
 */
export function chatBaseSegment() {
	return chatPersona();
}

/**
 * Decide se o chat guIAre deve aparecer para o usuário atual.
 */
export function canUseGuiare() {
	const config = PERSONA_CONFIG[chatPersona()];
	if (!config || !config.enabled) return false;

	const usernames = config.allowedUsernames || [];
	if (usernames.length && !usernames.includes(Cookie.get('nome'))) return false;

	const empreendimentos = config.allowedEmpreendimentos || [];
	if (empreendimentos.length) {
		const empreendimentoId = parseInt(Cookie.get('empreendimento_id'), 10);
		if (!empreendimentos.includes(empreendimentoId)) return false;
	}

	return true;
}

export default canUseGuiare;
